import React from 'react' 
import { useDispatch, useSelector } from 'react-redux'
import {
    fetchClassDetails,
    fetchClassNotesDetails
} from '../../actions'
const {useEffect} = React


const ClassRequirements = ({type,isFirm, classId})=>{
    const dispatch = useDispatch()
    const apiResponse = useSelector(state=>{
        const {fetchClassDetails, fetchClassNotesDetails} = state
        const {details} = fetchClassDetails
        const {notes} = fetchClassNotesDetails
        return{
            details,
            notes
        }
    })


    useEffect(()=>{
        if(classId){
            dispatch(fetchClassDetails(classId?.id))
            dispatch(fetchClassNotesDetails(classId?.id))
        }
    },[classId])


    var displayRequirements = []
    if(apiResponse.details?.data.length > 0){
        const filterActive = apiResponse.details?.data.filter((el)=>{
            return el.isActive
        })
        displayRequirements = filterActive.map((value,id)=>{
            return(
                <li>{id+1}.{value.textString}</li>
            )
        })
    }


    var displayNotesRequirements = []
    if(apiResponse.notes?.data.length > 0){
        const filterAct = apiResponse.notes?.data.filter((el)=>{
            return el.isActive
        })
        displayNotesRequirements = filterAct.map((value,id)=>{
            return(
                <li>{id+1}.{value.textString}</li>
            )
        })
    }

    const details = () =>{
        if(isFirm){
            return (
                <div>
                        <div className="dashboard-content-ctn d-flex">
                            <div className="content-requirement">
                                <span>APPLICATION REQUIREMENTS</span>
                                <ol>
                                    <li>1. Filling following requirements</li>
                                    <li>2. RDB Registration Certificate (Main Activities: Architectural and Engineering Activities and Related Technical Consultancy)</li>
                                    <li>3. Managing/Technical Director’s Practicing License</li>
                                    <li>4. Company Profile that includes a full Office Address</li>
                                    <li>5. RSSB Certificate</li>
                                    <li>6. RRA Tax Clearance Certificate</li>
                                    <li>7. Non-refundable application fees of Rwf 20,000 (Payable on Account No: 211-131222-1-5118-0 in the names of Institution of Engineers Rwanda open in GT Bank [Rwanda] Plc). The Bank slip should be attached</li>
                                    <li>8. Resume/CV of the Managing/Technical Director</li>
                                </ol>
                            </div>
                        </div>
                        <div className="dashboard-separator"></div>
                            <div className="dashboard-takenote-ctn">
                                <span>NOTE:</span> <br/>
                                <b> After being admitted as a Consulting Firm with the Institution of Engineers Rwanda, the Firm is required to pay annual subscription fees and certification fees amounting to Rwf 200,000 if it is registered as a Local Company and USD 500 if it is registered as a Foreign Company. Account no: 2110035556 in the names of Institute of Engineers Rwanda open in GT Bank (Rwanda) Plc.</b>
                        </div>
                    </div>
            )
        }
        switch(type){
            case 'Professional/Corporate Engineer': 
                return(
                        <div>
                        <div className="dashboard-content-ctn d-flex">
                            <div className="content-requirement">
                                <span>APPLICATION REQUIREMENTS</span>
                                <ol>
                                    <li>1. Filling following requirements</li>
                                    <li>2. Scan of notarized Degree certificates</li>
                                    <li>3. Scan of national identity cardentity card</li>
                                    <li>4. 1 passport photo</li>
                                    <li>5. Endorsed, Signed and Stamped Technical Report by Compliant registered Engineer for those applying to become Professional Engineers/Associates.</li>
                                    <li>6. Paying 10,000 RWF application Fee</li>
                                </ol>
                            </div>
                        </div>
                        <div className="dashboard-separator"></div>
                            <div className="dashboard-takenote-ctn">
                                <span>NOTE:</span> <br/>
                                <b>Every candidate for election or transfer to the class of Corporate Member shall satisfy the Institution, through its Governing Council, who may at their discretion call the candidate for interview, that he/she:-</b>
                                <ul>
                                    <li>
                                        •   Has obtained the degree of a Bachelor of Engineering or its equivalent awarded by a University or School of Engineering approved for the purpose by the Institution.
                                    </li>
                                    <li>
                                        •   Has passed the technical requirements and approved by the Institution to practice as an Engineer.
                                    </li>
                                    <li>
                                        •	Had at least two (2) years adequate practical experience in the practice of engineering, engineering research or engineering education, preferably under a Fellow or Corporate Member of the Institution, or under a member of another institution recognised by the Institution, through its competent authority; provided that this period shall be in a position of responsibility.
                                    </li>
                                    <li>
                                        •	To maintain a corporate Class he or she should attain the minimum allowable number of credit points in Continuous Professional Development assessment.
                                    </li>
                                    <li>
                                        •	Is a Corporate member of an Engineering Institution in Eastern Africa that has ratified the Mutual Recognition Agreement signed by Rwanda.
                                    </li>
                                    <li>
                                        •	His/her Country of origin has Mutual Recognition Agreement with Institution of Engineers Rwanda.
                                    </li>
                                    <li>
                                        •	For a foreigner who is a professional shall only need to provide the current practicing certificates to be registered as a professional.
                                    </li>
                                </ul>
                        </div>
                    </div>
                )

            case 'Graduate Engineer':

                return(
                    <div>
                    <div className="dashboard-content-ctn d-flex">
                        <div className="content-requirement">
                            <span>APPLICATION REQUIREMENTS</span>
                            <ol>
                                <li>1. Filling following requirements</li>
                                <li>2. Scan of notarized Degree certificates</li>
                                <li>3. Scan of national identity cardentity card</li>
                                <li>4. 1 passport photo</li>
                                <li>6. Paying 10,000 RWF application Fee</li>
                            </ol>
                        </div>
                    </div>
                    <div className="dashboard-separator"></div>
                        <div className="dashboard-takenote-ctn">
                            <span>NOTE:</span> <br/>
                            <b>Every candidate for admission or transfer to the class of Graduate shall satisfy the Institution, through its Council that he or she:-</b>
                            <ul>
                                <li>
                                    o	Has obtained the degree of a Bachelors in Engineering or its equivalent awarded by a University or School of Engineering approved for the purpose by the Institution.
                                </li>
                                <li>
                                    o	Has passed the technical requirements (technical report and interview) and approved by the Institution to practice as an Engineer.
                                </li>
                                <li>
                                    o	No person shall remain a Graduate after 5 years in this class.
                                </li>
                                <li>
                                    o	Is registered with the Institution of Engineers Rwanda as a graduate member.
                                </li>
                            </ul>
                    </div>
                </div>
            )

            case 'Professional Technologist':

                return(
                    <div>
                    <div className="dashboard-content-ctn d-flex">
                        <div className="content-requirement">
                            <span>APPLICATION REQUIREMENTS</span>
                            <ol>
                                <li>1. Filling following requirements</li>
                                <li>2. Scan of notarized Degree certificates</li>
                                <li>3. Scan of national identity cardentity card</li>
                                <li>4. 1 passport photo</li>
                                <li>6. Paying 5,000 RWF application Fee</li>
                            </ol>
                        </div>
                    </div>
                    <div className="dashboard-separator"></div>
                        <div className="dashboard-takenote-ctn">
                            <span>NOTE:</span> <br/>
                            <b>Every candidate for admission or transfer to the class of Graduate shall satisfy the Institution, through its Council that he or she:-</b>
                            <ul>
                                <li>
                                    o	A holder of Advanced Diploma(A1) in Technology/ in Engineering or other qualifications from a recognised program of study for the course.
                                </li>
                                <li>
                                    o	Has passed professional assessment conducted by the Institution of Engineers Rwanda.
                                </li>
                            </ul>
                    </div>
                </div>
            )

            case 'Graduate Technologist':

                return(
                    <div>
                    <div className="dashboard-content-ctn d-flex">
                        <div className="content-requirement">
                            <span>APPLICATION REQUIREMENTS</span>
                            <ol>
                                <li>1. Filling following requirements</li>
                                <li>2. Scan of notarized Degree certificates</li>
                                <li>3. Scan of national identity cardentity card</li>
                                <li>4. 1 passport photo</li>
                                <li>6. Paying 5,000 RWF application Fee</li>
                            </ol>
                        </div>
                    </div>
                    <div className="dashboard-separator"></div>
                        <div className="dashboard-takenote-ctn">
                            <span>NOTE:</span> <br/>
                            <b>Every candidate for admission or transfer to the class of Graduate shall satisfy the Institution, through its Council that he or she:-</b>
                            <ul>
                                <li>
                                    o	a holder of Advanced Diploma(A1) in Technology/ in Engineering or other qualifications from a recognised program of study for the course.
                                </li>
                                <li>
                                    o	Has passed professional assessment conducted by the Institution of Engineers Rwanda.
                                </li>
                                <li>
                                    o	No person shall remain a Graduate after 5 years in this class.
                                </li>
                            </ul>
                    </div>
                </div>
            )

            case 'Technician':

                return(
                    <div>
                    <div className="dashboard-content-ctn d-flex">
                        <div className="content-requirement">
                            <span>APPLICATION REQUIREMENTS</span>
                            <ol>
                                <li>1. Filling following requirements</li>
                                <li>2. Scan of notarized Degree certificates</li>
                                <li>3. Scan of national identity cardentity card</li>
                                <li>4. 1 passport photo</li>
                                <li>6. Paying 5,000 RWF application Fee</li>
                            </ol>
                        </div>
                    </div>
                    <div className="dashboard-separator"></div>
                        <div className="dashboard-takenote-ctn">
                            <span>NOTE:</span> <br/>
                            <b>Every candidate shall be eligible for registration as an engineering technician if that person is:-</b>
                            <ul>
                                <li>
                                    o	a holder of a Certificate (A2) or any Prior Learning Recognition tests in Engineering from a recognised program of study for the course.
                                </li>
                                <li>
                                    o	Has passed professional assessment conducted by the Institution of Engineers Rwanda.
                                </li>
                            </ul>
                    </div>
                </div>
            )
        }
    }


    return(
        <>
           {displayRequirements.length > 0 &&
           <> 
                <div className="dashboard-content-ctn d-flex">
                    <div className="content-requirement">
                        <span>APPLICATION REQUIREMENTS</span>
                        <ol>
                            {displayRequirements}
                        </ol>
                    </div>
                </div>
                <div className="dashboard-separator"></div>
                    {displayNotesRequirements?.length > 0 && <div className="dashboard-takenote-ctn">
                        <span>NOTE:</span> <br/>
                        <b>Every candidate shall be eligible for registration as {type} if that person is:-</b>
                        <ul>
                            {displayNotesRequirements}
                        </ul>
                    </div>}
            </>
            }
        </>
    )
}


export default ClassRequirements